// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__erxE+","label":"Checkbox_label__ARgfS"};